module.exports = function() {
  return new Worker(__webpack_public_path__ + "af0194db843b699f40bb.worker.js");
};